import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';
import { IMAGES } from '../../constants/images';

const articles = [
  {
    title: 'RIPS 2024: A Game Changer for Rajasthan Industries',
    source: 'Industry Insights',
    date: 'January 2025',
    excerpt: 'Expert analysis on how the new investment promotion scheme is transforming the industrial landscape of Rajasthan.'
  },
  {
    title: 'MSMEs Benefit from Government Subsidy Schemes',
    source: 'Business Today',
    date: 'December 2024',
    excerpt: 'How financial consultants are helping small businesses navigate complex subsidy application processes.'
  },
  {
    title: 'Youth Entrepreneurship Gets Boost with VYUPY',
    source: 'Startup Weekly',
    date: 'November 2024',
    excerpt: 'Young entrepreneurs find support through government schemes with expert guidance from consultancy firms.'
  }
];

export const AboutPress = () => (
  <section className="py-24" data-testid="press-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <span className="inline-block px-4 py-2 bg-[#f1f5f9] rounded-full text-sm font-medium text-[#3b5998] mb-4">
          Press & Media
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          In The News
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Featured articles and press coverage highlighting our work in financial consultancy.
        </p>
      </motion.div>

      <div className="mb-16">
        <h3 className="font-heading text-xl font-semibold text-[#0f172a] mb-6 text-center">
          Recent Press Coverage
        </h3>
        <div className="grid md:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-xl shadow-lg overflow-hidden border border-slate-100"
          >
            <img
              src={IMAGES.press1}
              alt="Dainik Bhaskar - ICAI MSME Festival 2025"
              className="w-full h-auto"
            />
            <div className="p-4 bg-gradient-to-r from-[#3b5998]/5 to-[#00bcd4]/5">
              <p className="text-sm font-medium text-[#0f172a]">Dainik Bhaskar - Chittorgarh</p>
              <p className="text-xs text-[#64748b]">29 June 2025</p>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="bg-white rounded-xl shadow-lg overflow-hidden border border-slate-100"
          >
            <img
              src={IMAGES.press2}
              alt="MSME Day Festival 2025 Press Coverage"
              className="w-full h-auto"
            />
            <div className="p-4 bg-gradient-to-r from-[#3b5998]/5 to-[#00bcd4]/5">
              <p className="text-sm font-medium text-[#0f172a]">MSME Day Festival 2025</p>
              <p className="text-xs text-[#64748b]">International MSME Day Celebration</p>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {articles.map((article, index) => (
          <motion.div
            key={article.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
          >
            <Card className="h-full border border-slate-100 hover:border-[#00bcd4]/30 transition-colors bg-white">
              <CardContent className="p-6">
                <div className="flex items-center gap-2 mb-4">
                  <span className="text-xs font-medium text-[#00bcd4]">{article.source}</span>
                  <span className="text-slate-300">•</span>
                  <span className="text-xs text-[#64748b]">{article.date}</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-[#0f172a] mb-3">
                  {article.title}
                </h3>
                <p className="text-[#64748b] text-sm leading-relaxed">
                  {article.excerpt}
                </p>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
